import {
	Component,
	Host,
	h,
	Prop,
	Event,
	EventEmitter,
	Element,
	State,
	Watch,
} from '@stencil/core';

@Component({
	tag: 'search-result-item',
	styleUrl: 'search-result-item.scss',
	shadow: true,
})
export class SearchResultItem {
	@Prop() accessibleTitle: string;
	@Prop() heading: string;
	@Prop() image: { src: string; alt: string };
	@Prop() variant: string = 'location';
	@Prop() url: string = null;

	@Watch('heading')
	validateHeading(newValue, oldValue) {
		if ('string' !== typeof this.heading && !this.accessibleTitle) {
			console.error('Heading is not a string, please also provide an `accessibleTitle`');
		}
	}

	@Element() el: HTMLElement;

	@State() hovered = false;

	@State() classNames = {
		host: `search-result search-result--${this.variant}${this.hovered ? ' hovered' : ''}`,
		figure: `search-result-image search-result-image--${this.variant}`,
		body: `search-result-body search-result--${this.variant}`,
		title: `search-result-title${this.variant !== 'location' ? ` no-border` : ''}`,
	};

	constructor() {
		this.el.addEventListener('mouseenter', () => (this.hovered = true));
		this.el.addEventListener('mouseleave', () => (this.hovered = false));
	}

	componentWillRender() {
		if (!!this.image) {
			this.classNames.host += ' has-image';
		}
	}

	ImageHTML() {
		if (!this.image) {
			return;
		}
		if (this.url) {
			return (
				<a title={`View ${this.accessibleTitle}`} href={this.url}>
					<img loading="lazy" {...this.image} />
				</a>
			);
		}
		return <img loading="lazy" {...this.image} />;
	}

	HeadingHTML() {
		if (null !== this.url) {
			return (
				<a title={`View ${this.accessibleTitle}`} href={this.url}>
					{this.heading}
				</a>
			);
		}
		return this.heading;
	}

	render() {
		return (
			<Host class={this.classNames.host}>
				<figure class={this.classNames.figure}>{this.ImageHTML()}</figure>

				<div class={this.classNames.body}>
					<p class={this.classNames.title}>{this.HeadingHTML()}</p>
					<div class="search-result-content">
						<slot></slot>
					</div>
				</div>
			</Host>
		);
	}
}
